import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './ThankYou.css';

function ThankYou() {
  const location = useLocation();
  const { token, attending } = location.state || {};

  return (
    <div className="thank-you-page">
      <div className="container">
        <div className="card text-center">
          <div className="thank-you-content">
            <h1>Thank You!</h1>
            <p className="thank-you-message">
              Your RSVP has been received. We appreciate you taking the time to respond!
            </p>
            {attending === 'yes' && token && (
              <>
                <p className="thank-you-submessage">
                  We look forward to celebrating with you on our special day.
                </p>
                <div className="invitation-link-section">
                  <p className="invitation-intro">
                    View your personalized wedding invitation:
                  </p>
                  <Link to={`/invitation/${token}`} className="btn btn-primary mt-10">
                    View Invitation
                  </Link>
                </div>
              </>
            )}
            {attending === 'no' && (
              <p className="thank-you-submessage">
                We're sorry you can't make it, but we appreciate you letting us know.
              </p>
            )}
            <div className="couple-signature">
              <p>With love,</p>
              <p className="signature-names">Janelle & Justine</p>
            </div>
            <Link to="/" className="btn btn-secondary mt-20">
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
